import { ApiResponse, DashboardSummary, LeaveApplication } from '@/types';
import { api } from './client';

export const dashboardService = {
  getSummary: async () => {
    const response = await api.get<ApiResponse<DashboardSummary>>('dashboard/summary');
    return response.responseBody.data;
  },
  getTeamCalendar: async () => {
    const response = await api.get<ApiResponse<LeaveApplication[]>>('dashboard/calendar');
    return response.responseBody.data;
  },
};
